import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ParticleService} from '@core/services/particle.service';
import {CommandService} from '@core/services/command.service';
import {RouterModule} from '@angular/router';
import {PlatformCommand} from '@shared/commands/command-base';
import {PlatformToolExpertServicesHandler} from '@features/expert-services/services/platform-tool-expert-services-handler';
import {SharedModule} from '@shared/shared.module';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {TransactionTrackerApiProvider} from '@features/transaction-tracker/transaction-tracker-api-provider';
import {
  PlatformToolTransactionTrackerHandler,
} from '@features/transaction-tracker/services/platform-tool-transaction-tracker-handler';
import {transactionTrackerRoutes} from '@features/transaction-tracker/transaction-tracker.routes';
import {Api} from '@shared/constants/common-field.constants';
import {TransactionTrackerDynamicComponentHelper} from '@features/transaction-tracker/transaction-tracker-dynamic-component-helper';
import { PlatformToolBucketFolderViewComponent } from './components/platform-tool-bucket-folder-view/platform-tool-bucket-folder-view.component';


@NgModule({
  declarations: [
    PlatformToolBucketFolderViewComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(transactionTrackerRoutes),
    SharedModule
  ]
})
export class TransactionTrackerModule {
  constructor(private particleService: ParticleService,
              private commandService: CommandService,
              private platformToolExpertServicesHandler: PlatformToolExpertServicesHandler,
              private platformToolTransactionTrackerHandler: PlatformToolTransactionTrackerHandler,
              private platformApiProvider: PlatformApiProvider) {
    TransactionTrackerDynamicComponentHelper.init();
    TransactionTrackerDynamicComponentHelper.register('PlatformToolTransactionTrackerHandler', platformToolTransactionTrackerHandler);

    this.platformApiProvider.registerAtTop(new TransactionTrackerApiProvider());

    let command = new PlatformCommand('CreateTransactionDataToolLinkCommand', Api.TransactionTrackerApi);
    this.commandService.registrPlatformLinkCommand('/transaction-tracker/transactions', command);

    command = new PlatformCommand('CreateTransactionEntitiesToolLinkCommand', Api.TransactionTrackerApi);
    this.commandService.registrPlatformLinkCommand('/transaction-tracker/entities', command);

    command = new PlatformCommand('CreateConsolidationRulesToolLinkCommand', Api.TransactionTrackerApi);
    this.commandService.registrPlatformLinkCommand('/transaction-tracker/consolidation-rules', command);

    command = new PlatformCommand('CreateConsolidationTransactionsToolLinkCommand', Api.TransactionTrackerApi);
    this.commandService.registrPlatformLinkCommand('/transaction-tracker/consolidation-transactions', command);

    command = new PlatformCommand('CreateTransactionTrackerAnalyticToolLinkCommand', Api.TransactionTrackerApi);
    this.commandService.registrPlatformLinkCommand('/transaction-tracker/analytics', command);
    command = new PlatformCommand('CreateTransactionBucketToolLinkCommand', Api.TransactionTrackerApi);
    this.commandService.registrPlatformLinkCommand('/transaction-tracker/transaction-buckets', command);

    command = new PlatformCommand('CreateFxRatesToolLinkCommand', Api.TransactionTrackerApi);
    this.commandService.registrPlatformLinkCommand('/transaction-tracker/custom-rates/fx-rates', command);

    command = new PlatformCommand('CreateWhtRatesToolLinkCommand', Api.TransactionTrackerApi);
    this.commandService.registrPlatformLinkCommand('/transaction-tracker/custom-rates/wht-rates', command);

    command = new PlatformCommand('CreateFieldMappingToolLinkCommand', Api.TransactionTrackerApi);
    this.commandService.registrPlatformLinkCommand('/transaction-tracker/data-mapping/field-mapping', command);

    command = new PlatformCommand('CreateEntityMappingToolLinkCommand', Api.TransactionTrackerApi);
    this.commandService.registrPlatformLinkCommand('/transaction-tracker/data-mapping/entity-mapping', command);

    command = new PlatformCommand('CreateStreamMappingToolLinkCommand', Api.TransactionTrackerApi);
    this.commandService.registrPlatformLinkCommand('/transaction-tracker/data-mapping/stream-mapping', command);

    command = new PlatformCommand('CreateTransactionBucketToolLinkCommand', Api.TransactionTrackerApi);
    this.commandService.registrPlatformLinkCommand('/transaction-tracker/buckets', command);
  }
}
